import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {useContentful} from "react-contentful";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getPages($slug: String!, $locale: String!) {
  pageCollection(limit: 1, where: { slug: $slug }, locale: $locale) {
    items {
      title
      slug
      content {
        ... on StandardPage {
          content {
            links {
              assets {
                block {
                  sys {
                    id
                  }
                  url
                  description
                }
              }
              entries {
                inline {
                  ... on HtmlComponents {
                    sys{
                      id
                    }
                    id
                    label
                    type,
                    title
                  }
                }
                block {
                  ... on HtmlComponents {
                    sys{
                      id
                    }
                    id
                    label
                    type,
                    title
                  }
                }
              }
            }
            json
          }
        }
      }
      seo {
        ... on Seo {
          title
          description
          image {
            url
          }
        }
      }
    }
  }
}`;

// DEPRECATED
// Getting StandardPage content with GraphQL is not used any mode
// StandardPage content is empty, and HTMLComponents are used instead in order to contruct the page
// If we want in the future to use the content field, somewhere, maybe this hook comes in hand
export const usePagesGql = (slug) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: { slug: slug, locale: localeUppercase}, errorPolicy: "all", fetchPolicy: "no-cache"});

    const page = data?.pageCollection?.items[0]?.content?.content?.json;
    const assetsMap = new Map();
    const htmlComponentsMap = new Map();

    data?.pageCollection?.items[0]?.content?.content?.links?.assets?.block?.forEach((asset) => {
        assetsMap.set(asset?.sys?.id, {url: asset?.url, description: asset?.description});
    });

    data?.pageCollection?.items[0]?.content?.content?.links?.entries?.inline?.forEach((entry) => {
        htmlComponentsMap.set(entry?.sys?.id, {id: entry?.id, label: entry?.label, type: entry?.type});
    });

    data?.pageCollection?.items[0]?.content?.content?.links?.entries?.block?.forEach((entry) => {
        htmlComponentsMap.set(entry?.sys?.id, {id: entry?.id, label: entry?.label, type: entry?.type});
    });

    if (error?.message) {
        logger(error?.message, "error", "usePagesGql", error?.stack);
    }

    return {
        page,
        assetsMap,
        htmlComponentsMap,
        loading,
        error
    };
};

export const usePagesRest = (slug) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();

    const { data, error, loading } = useContentful({
        contentType: "page",
        query: {
            "fields.slug[in]": slug,
        },
        locale: localeUppercase
    });

    const pageTitle = data?.items[0]?.fields?.title;
    const htmlComponents = data?.items[0]?.fields?.content?.fields?.htmlComponents;
    const seoData = data?.items[0]?.fields?.seo?.fields;

    if (error?.message) {
        logger(error?.message, "error", "usePagesRest", error?.stack);
    }

    return {
        pageTitle,
        seoData,
        htmlComponents,
        pageLoading: loading,
        pageError: error
    };
};
